var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Array.isArray(_vm.baseData) && _vm.baseData.length)?_c('div',{staticClass:"recommend"},[_c('div',{staticClass:"title pl12"},[_vm._v("\n        产品推荐\n    ")]),_c('div',{staticClass:"list",on:{"~scroll":function($event){_vm.eventTrack('SCROLL_INDEX_RECOMMEND')}}},[_c('ul',_vm._l((_vm.baseData),function(form,i){return _c('card',{key:i,attrs:{"form":form}})}))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31b8cda8","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./libs/components/detail/recommend/index.vue
// module id = 748
// module chunks = 0